import React from 'react';
export function BenefitsStrip() {
  return <section className="bg-sure-dark border-t-2 border-sure-accent w-full" data-id="element-25">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 md:py-24" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-16" data-id="element-27">
          {/* Column 1 */}
          <div className="flex flex-col" data-id="element-28">
            <h3 className="text-sure-white text-sm md:text-base font-bold uppercase tracking-widest mb-4" data-id="element-29">
              Operational Clarity
            </h3>
            <p className="text-sure-gray text-sm leading-relaxed font-light" data-id="element-30">
              Measure boarding, alighting and dwell behaviour at stop level
            </p>
          </div>

          {/* Column 2 */}
          <div className="flex flex-col md:border-l md:border-white/10 md:pl-8 lg:pl-16" data-id="element-31">
            <h3 className="text-sure-white text-sm md:text-base font-bold uppercase tracking-widest mb-4" data-id="element-32">
              Safer Networks
            </h3>
            <p className="text-sure-gray text-sm leading-relaxed font-light" data-id="element-33">
              Identify high-risk locations and behavioural patterns to
              prioritise interventions
            </p>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col md:border-l md:border-white/10 md:pl-8 lg:pl-16" data-id="element-34">
            <h3 className="text-sure-white text-sm md:text-base font-bold uppercase tracking-widest mb-4" data-id="element-35">
              Evidence-Based Planning
            </h3>
            <p className="text-sure-gray text-sm leading-relaxed font-light" data-id="element-36">
              Aggregate anonymised signals for network-level decision making
            </p>
          </div>
        </div>
      </div>
    </section>;
}